module.exports = __webpack_public_path__ + "img/zden.556ed953.png";